import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

const useStyles = makeStyles(
  () => ({
    buttonSpan: {
      display: "flex",
      flexDirection: "row",
      marginBottom: "20px"
    },
    cancelButton: {
      backgroundColor: "#F4F4F4",
      border: "1px solid #E5E5E5",
      margin: "0 15px 0 20px",
      width: "197px"
    },
    closeIcon: {},
    dialogTexts: {
      display: "flex",
      flexDirection: "column"
    },
    iconContainer: {
      display: "flex",
      justifyContent: "flex-end"
    },
    onConfirmButton: {
      "&:active": {
        "& span": {
          color: "#002972"
        },
        backgroundColor: "#FFCE22",
        boxShadow: "inset 0px 0px 0px 2px #D0A73E"
      },
      "&:hover": {
        backgroundColor: "#FFD15C",
        boxShadow: "inset 0px 0px 0px 1px #D0A73E"
      },
      backgroundColor: "#FFD15C",
      margin: "0 20px 0 15px",
      width: "197px"
    }
  }),
  { name: "HomeLocationDeleteDialog" }
);

interface DeleteDialogProps {
  open: boolean;
  data: any;
  onClose: () => void;
  onConfirm?: (data) => void;
  onCancel: () => void;
  title: string;
  cancelButtonLabel: string;
  confirmButtonLabel: string;
}

function HomeLocationDeleteDialog(props: DeleteDialogProps) {
  const classes = useStyles(props);
  const {
    data,
    open,
    onClose,
    onConfirm,
    onCancel,
    title,
    cancelButtonLabel,
    confirmButtonLabel
  } = props;

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        style={{ textAlign: "center" }}
      >
        <DialogContent>
          <span className={classes.iconContainer}>
            <CloseIcon
              fontSize="small"
              onClick={onClose}
              className={classes.closeIcon}
            />
          </span>
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>

          <DialogContentText>
            <label className={classes.dialogTexts}>
              Are you use you want to delete
              <b>{data?.name} ?</b>
              This process cannot be undone.
            </label>
          </DialogContentText>
        </DialogContent>
        <span className={classes.buttonSpan}>
          <Button
            color="primary"
            onClick={onCancel}
            className={classes.cancelButton}
          >
            {cancelButtonLabel}
          </Button>
          <Button
            color="primary"
            onClick={onConfirm}
            className={classes.onConfirmButton}
          >
            {confirmButtonLabel}
          </Button>
        </span>
      </Dialog>
    </div>
  );
}

export default HomeLocationDeleteDialog;
